import { render, staticRenderFns } from "./ProjectLayer.vue?vue&type=template&id=60086e9d"
import script from "./ProjectLayer.vue?vue&type=script&lang=js"
export * from "./ProjectLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports